import queryString from "query-string";

export default (apiUrl, httpClient) => ({
  getList: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify(params.filter),
    };
    return httpClient(apiUrl)
      .get(`${apiUrl}/${resource}?${queryString.stringify(query)}`)
      .then((response) => response.data)
      .then((data) => {
        const results = data.results.map((d) => ({ ...d, id: d._id }));
        return {
          data: results,
          total: data.total,
        };
      })
      .catch((err) => console.log(err));
  },
  getOne: (resource, params) =>
    httpClient(apiUrl)
      .get(`${apiUrl}/${resource}/${params.id}`)
      .then(({ data }) => ({
        data,
      }))
      .catch((err) => console.log(err)),
  getMany: (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };

    return httpClient(apiUrl)
      .get(`/${resource}?${queryString.stringify(query)}`)
      .then((response) => response.data)
      .then((data) => {
        const results = data.results.map((d) => ({ ...d, id: d._id }));
        return {
          data: results,
          total: data.total,
        };
      })
      .catch((err) => console.log(err));
  },
  getManyReference: (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;

    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify(
        Object.assign(Object.assign({}, params.filter), {
          [params.target]: params.id,
        }),
      ),
    };

    return httpClient(apiUrl)
      .get(`/${resource}?${queryString.stringify(query)}`)
      .then((response) => response.data)
      .then((data) => {
        const results = data.results.map((x) => ({ ...x, id: x._id }));
        return {
          data: results,
          total: data.total,
        };
      })
      .catch((err) => console.log(err));
  },
  update: (resource, params) => {
    return httpClient(apiUrl)
      .put(`/${resource}/${params.id}`, { ...params.data })
      .then((response) => ({
        data: { ...response.data, id: response.data._id },
      }))
      .catch((err) => console.log(err));
  },
  // simple-rest doesn't handle provide an updateMany route, so we fallback to calling update n times instead
  updateMany: (resource, params) =>
    Promise.all(params.ids.map((id) => httpClient(apiUrl).put(`/${resource}/${id}`)))
      .then((responses) => ({ data: responses.map(({ json }) => json.id) }))
      .catch((err) => console.log(err)),
  create: (resource, params) => {
    return httpClient(apiUrl)
      .post(`/${resource}`, params.data)
      .then((response) => response.data)
      .then((data) => ({ data: { ...data, id: data._id } }))
      .catch((err) => console.log(err));
  },
  delete: async (resource, params) => {
    return httpClient(apiUrl)
      .delete(`/${resource}/${params.id}`)
      .then(() => ({ data: { id: params.id } }))
      .catch((err) => new Error(`Fail to delete Item: ${params.id}`));
  },
  deleteMany: (resource, params) =>
    Promise.all(params.ids.map((id) => httpClient(apiUrl).delete(`/${resource}/${id}`)))
      .then((responses) => {
        const ids = responses.map((response) => response.data.id);
        return { data: ids };
      })
      .catch((err) => console.log(err)),
});
